module.exports = "../content/c470ca2b5b4f4437a3fe71b113a289a2.ttf";